import React, { useState, useEffect } from "react";
import SideBar from "./views/SideBar";
import "rsuite/dist/rsuite.min.css";
import HeaderName from "./views/HeaderName";
import { Button, Pagination } from "rsuite";
import axios from "axios";

export default function StockHistory() {
  const [data, setData] = useState({
    medicineItems: [],
    procedureItems: [],
    accessoryItems: [],
    generalItems: [],
  });
  const [activeCategory, setActiveCategory] = useState("medicineItems");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(500); // Define the number of items per page

  // Fetch stock data on component mount
  useEffect(() => {
    axios
      .get(
        "http://192.168.1.5:9090/api/stocks/stock-history-ho"
      )
      .then((response) => {
        if (response.data.success) {
          setData(response.data.data);
        } else {
          console.error("Failed to fetch stock data");
        }
      })
      .catch((error) => {
        console.error("Error fetching stock data:", error);
      });
  }, []);

  // Get paginated items for the current page
  const paginatedItems = (items) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return items.slice(startIndex, endIndex);
  };

  // Render table rows
  const renderTableRows = (items) => {
    return items.map((item, index) => (
      <tr key={index}>
        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
        <td>{item.code}</td>
        <td>{item.name}</td>
        <td>{item.openingQty || 0}</td>
        <td>{item.transferToHoRequest || 0}</td>
        <td>{item.transferedQty || 0}</td>
        <td>{item.purchaseRequest || 0}</td>
        <td>{item.closingQty || 0}</td>
      </tr>
    ));
  };

  return (
    <div className="App">
      <div className="wrapper">
        <HeaderName />
        <SideBar />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">Stock History</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="row">
                        <div className="col-md-8">
                          <div className="row">
                            {[
                              "medicineItems",
                              "procedureItems",
                              "accessoryItems",
                              "generalItems",
                            ].map((category, index) => (
                              <div className="col-3" key={index}>
                                <Button
                                  onClick={() => {
                                    setActiveCategory(category);
                                    setCurrentPage(1); // Reset to page 1 when category changes
                                  }}
                                >
                                  {category.replace(/Items/, " Items")}
                                </Button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="table-responsive text-black"
                            id="slimtest2"
                          >
                            <table
                              className="table table-hover"
                              id="filter_date"
                            >
                              <thead>
                                <tr>
                                  <th>No</th>
                                  <th>Code</th>
                                  <th>Name</th>
                                  <th>Opening Stock</th>
                                  <th>Transfer To Ho</th>
                                  <th>Transfer To Branch</th>
                                  <th>Purchase Requests</th>
                                  <th>Closing Stock</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data[activeCategory] &&
                                  data[activeCategory].length ? (
                                  renderTableRows(
                                    paginatedItems(data[activeCategory])
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={8} className="text-center">
                                      No Data Available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="d-flex justify-content-center mt-3">
                            <Pagination
                              total={data[activeCategory]?.length || 0}
                              limit={itemsPerPage}
                              activePage={currentPage}
                              onChangePage={(page) => setCurrentPage(page)}
                              prev
                              next
                              ellipsis
                              boundaryLinks
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer" style={{ marginTop: "50px;" }}>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href="http://www.kwintechnologies.com">K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
};

// export default StockHistory;
